import Vue from 'vue'

import { ChatRoomContext } from './chat-room-context'
import { MessengerContext } from '..'

export class ChatRoomContextPool {

  messengerContext: MessengerContext
  _contexts: Record<number, ChatRoomContext> = {}

  constructor (messengerContext: MessengerContext) {
    this.messengerContext = messengerContext
  }

  context (chatRoomId: number) {
    let context_ = this._contexts[chatRoomId]
    if (!context_) {
      context_ = new ChatRoomContext(this.messengerContext.mainStore, chatRoomId)
      this._contexts[chatRoomId] = Vue.observable(context_)
    }
    return context_
  }

  cleanup () {
    this._contexts = {}
  }

}